import React, { useEffect, useState } from "react";
import { Container, Row, Col, Image, Table } from "react-bootstrap";
import logo from "../../assets/images/Logo.png";
import axios from "axios";
import Apiurl from "../environment/Apiurl";
import { useParams, useNavigate } from "react-router-dom";

const Hospitalbill = () => {
  const handlePrint = () => {
    window.print();
  };
  const { id } = useParams();
  const navigate = useNavigate();
  const [responseData, setResponseData] = useState(null);
  const [visitCount, setVisitCount] = useState(0);

  // Fetch prescription or appointment data
  const fetchPrescriptionData = async () => {
    try {
      console.log("Fetching data for ID:", id);
      console.log("ID type:", typeof id);
      console.log("ID length:", id?.length);

      // First, try to get all prescriptions and find the matching one
      try {
        console.log("Trying to fetch all prescriptions and filter...");
        const allPrescriptionsResponse = await axios.get(
          `${Apiurl}/prescriptions`
        );
        if (
          allPrescriptionsResponse.status === 200 &&
          Array.isArray(allPrescriptionsResponse.data)
        ) {
          const matchingPrescription = allPrescriptionsResponse.data.find(
            (prescription) => prescription._id === id || prescription.id === id
          );

          if (matchingPrescription) {
            console.log("Found matching prescription:", matchingPrescription);
            setResponseData(matchingPrescription);

            // Fetch visit count based on patient_id
            const patientId =
              matchingPrescription?.appointment?.patient?.patient_id ||
              matchingPrescription?.patient_id ||
              // matchingPrescription?.appointment?.patient_id ||
              matchingPrescription.appointment.patient_id._id;
            // matchingPrescription.appointment.patient_id.patient_id;
            if (patientId) {
              fetchVisitCount(patientId);
            }

            console.log(
              "the patientId after mathc found is :",
              matchingPrescription.appointment.patient_id.patient_id
            );

            console.log(
              "the patientId after mathc found is :",
              matchingPrescription?.appointment?.patient?.patient_id
            );
            console.log(
              "the patientId after mathc found is :",
              matchingPrescription?.patient_id
            );
            console.log(
              "the patientId after mathc found is :",
              matchingPrescription?.appointment?.patient_id
            );
            console.log(
              "the final patientId after mathc found is :",
              patientId
            );

            return;
          } else {
            console.log("No matching prescription found in all prescriptions");
          }
        }
      } catch (allPrescriptionsError) {
        console.log(
          "Failed to fetch all prescriptions:",
          allPrescriptionsError.message
        );
      }

      // Try different prescription endpoint patterns
      const prescriptionEndpoints = [
        `${Apiurl}/prescriptions/${id}`,
        `${Apiurl}/prescription/${id}`,
        `${Apiurl}/prescriptions/details/${id}`,
        `${Apiurl}/prescription-data/${id}`,
        `${Apiurl}/prescriptions/single/${id}`,
      ];

      let prescriptionData = null;

      for (const endpoint of prescriptionEndpoints) {
        try {
          console.log("Trying endpoint:", endpoint);
          const response = await axios.get(endpoint);
          if (response.status === 200 && response.data) {
            prescriptionData = response.data;
            console.log(
              "Successfully fetched prescription data from:",
              endpoint
            );
            console.log("Fetched Prescription Data:", prescriptionData);
            break;
          }
        } catch (endpointError) {
          console.log(
            `Failed to fetch from ${endpoint}:`,
            endpointError.message
          );
        }
      }

      if (prescriptionData) {
        setResponseData(prescriptionData);

        // Fetch visit count based on patient_id
        const patientId =
          prescriptionData?.appointment?.patient?.patient_id ||
          prescriptionData?.patient_id ||
          prescriptionData?.appointment?.patient_id;
        if (patientId) {
          fetchVisitCount(patientId);
        }
        return;
      }

      // Fallback: try to fetch as appointment data
      console.log("Trying to fetch as appointment data...");
      const appointmentEndpoints = [
        `${Apiurl}/appointments/${id}`,
        `${Apiurl}/appointment/${id}`,
      ];

      for (const endpoint of appointmentEndpoints) {
        try {
          console.log("Trying appointment endpoint:", endpoint);
          const response = await axios.get(endpoint);
          if (response.status === 200) {
            const data = Array.isArray(response.data)
              ? response.data[0]
              : response.data;
            if (data) {
              setResponseData(data);
              console.log("Fetched Appointment Data:", data);

              if (data?.patient_id) {
                fetchVisitCount(data.patient_id);
              }
              return;
            }
          }
        } catch (endpointError) {
          console.log(
            `Failed to fetch from ${endpoint}:`,
            endpointError.message
          );
        }
      }

      console.error("Failed to fetch data from all endpoints");
      console.log("Available endpoints to try:");
      console.log("- Check if your API has a different prescription endpoint");
      console.log("- Verify the ID format is correct");
      console.log("- Check if the prescription exists in the database");
    } catch (error) {
      console.error("General error in fetchPrescriptionData:", error.message);
    }
  };

    useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const fetchVisitCount = async (patientId) => {
    try {
      let response = await axios.get(
        `${Apiurl}/appointments?patient_id=${patientId}`
      );
      console.log("response data from hospital bill", response);
      let appointments = response.data || [];

      // Log API response for debugging
      console.log(`API Response for patient_id ${patientId}:`, appointments);

      // If API doesn't filter correctly, fetch all appointments and filter client-side
      if (!appointments.every((appt) => appt.patient_id === patientId)) {
        console.warn(
          "API did not filter by patient_id, fetching all appointments"
        );
        response = await axios.get(`${Apiurl}/appointments`);
        appointments = response.data || [];
        appointments = appointments.filter(
          (appt) => appt.patient_id === patientId
        );
      }

      setVisitCount(appointments.length || 0);
      console.log(`Visit count for patient ${patientId}:`, appointments.length);
    } catch (error) {
      console.error("Error fetching visit count:", error.message);
      setVisitCount(0);
      console.log(`Fallback visit count for patient ${patientId}: 0`);
    }
  };

  useEffect(() => {
    fetchPrescriptionData();
  }, [id, navigate]);

  // Shows dose type ("Drops"/"Counts") for new records, falling back to
  // the legacy time value ("HH:MM") or "meal" for older prescriptions.
  const formatDoseLabel = (slot) => {
    const value = slot?.dose_type || slot?.time;
    if (!value || value === "0" || value === "0:00") return "meal";
    if (value === "drops" || value === "counts") {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
    return value;
  };

  const formatTiming = (timing) => {
    const times = [];

    if (timing.fn?.before === "1" || timing.fn?.before === "true") {
      times.push(`Morning (Before ${formatDoseLabel(timing.fn)})`);
    }
    if (timing.fn?.after === "1" || timing.fn?.after === "true") {
      times.push(`Morning (After ${formatDoseLabel(timing.fn)})`);
    }

    if (timing.an?.before === "1" || timing.an?.before === "true") {
      times.push(`Afternoon (Before ${formatDoseLabel(timing.an)})`);
    }
    if (timing.an?.after === "1" || timing.an?.after === "true") {
      times.push(`Afternoon (After ${formatDoseLabel(timing.an)})`);
    }

    if (timing.night?.before === "1" || timing.night?.before === "true") {
      times.push(`Night (Before ${formatDoseLabel(timing.night)})`);
    }
    if (timing.night?.after === "1" || timing.night?.after === "true") {
      times.push(`Night (After ${formatDoseLabel(timing.night)})`);
    }

    return times.join(", ");
  };

  // Helper function to safely access patient data
  const getPatientData = (field) => {

    // Prioritize prescription_weight for weight_kg
    if (field === "prescription_weight" && responseData?.prescription_weight) {
      return responseData?.prescription_weight;
    }
    if (responseData?.appointment?.patient) {
      return responseData.appointment.patient[field];
    }
    if (responseData?.patients_details?.[0]) {
      return responseData.patients_details[0][field];
    }

    // this is the new code
    if (responseData?.appointment?.patient_id) {
      return responseData?.appointment?.patient_id?.[field];
    }

    return null;
  };


  // Helper function to safely access doctor data
  const getDoctorData = (field) => {
    if (responseData?.appointment?.doctor_id) {
      return responseData.appointment.doctor_id[field];
    }
    if (responseData?.doctor_details?.[0]) {
      return responseData.doctor_details[0][field];
    }
    return null;
  };

  // Helper function to safely access prescription data
  const getPrescriptionData = (field) => {
    if (responseData?.prescription_data_details?.[0]) {
      return responseData.prescription_data_details[0][field];
    }
    return null;
  };

  return (
    <>
      <div className="d-flex justify-content-between">
        <div className="mt-2 d-print-none">
          <button
            className="btn btn-secondary btn-sm ms-2"
            onClick={() => navigate("/appointments")}
          >
            Back
          </button>
        </div>
        <Container
          fluid
          style={{
            padding: "10px",
            fontSize: "14px",
            lineHeight: "1.4",
            fontFamily: "Arial, sans-serif",
            width: "100%",
            maxWidth: "210mm",
            margin: "0 auto",
            boxSizing: "border-box",
            border: "1px solid black",
          }}
        >
          <Row style={{ marginBottom: "15px" }}>
            <Col
              xs={6}
              style={{
                flexDirection: "column",
              }}
            >
              <Image
                src={logo}
                alt="4Health Homeopathy"
                style={{ maxWidth: "100px", marginBottom: "5px" }}
              />
              <h5 style={{ fontSize: "16px", margin: "5px 0" }}>
                4Health Homeopathy
              </h5>
            </Col>
            <Col
              xs={6}
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                textAlign: "right",
                padding: "8px",
              }}
            >
              <h4 style={{ fontSize: "18px", margin: "0" }} className="fw-bold">
                {getDoctorData("doctor_name") || "Yoga Instructor"}
              </h4>
              <p style={{ fontSize: "14px", margin: "2px 0" }}>
                {getDoctorData("qualification") || "Yoga Instructor"}
              </p>
              <p style={{ fontSize: "14px", margin: "2px 0" }}>
                {getDoctorData("speciality") || "Yoga Instructor"}
              </p>
            </Col>
          </Row>

          <Row>
            <Col md={6} style={{ fontSize: "14px", marginBottom: "10px" }}>
              <p style={{ margin: "2px 0" }}>
                <strong>Patient ID:</strong> {getPatientData("patient_id") || "N/A"}
              </p>
              <p style={{ margin: "2px 0" }}>
                <strong>Patient:</strong>{" "}
                {getPatientData("first_name") || "N/A"}{" "}
                {getPatientData("last_name") || ""} (
                {getPatientData("age") || "N/A"}y,{" "}
                {getPatientData("gender") || "N/A"})
              </p>
              <p style={{ margin: "2px 0" }}>
                <strong>Partner:</strong>{" "}
                {getPatientData("spouse_name") || "N/A"}
              </p>
            </Col>
            <Col
              md={6}
              style={{
                fontSize: "14px",
                textAlign: "right",
                marginBottom: "10px",
              }}
              className="print-right"
            >
              <p style={{ margin: "2px 0" }}>
                <strong>Date:</strong>{" "}
                {responseData?.date ||
                  responseData?.appointment_date ||
                  new Date().toLocaleDateString()}
              </p>
              <p style={{ margin: "2px 0" }}>
                <strong>Next Visit Date:</strong>{" "}
                {responseData?.next_visit_date ||
                  responseData?.prescription_data_details?.[0]
                    ?.next_visit_date ||
                  "N/A"}
              </p>
              <p style={{ margin: "2px 0" }}>
                <strong>Visit:</strong> {visitCount || "N/A"}
              </p>
            </Col>
          </Row>
          <hr style={{ margin: "10px 0", border: "1px solid #000" }} />

          <Row>
            <Col xs={12} style={{ fontSize: "14px", marginBottom: "10px" }}>
              <p style={{ margin: "2px 0" }}>
                <strong>Height:</strong> {getPatientData("height_cm") || "N/A"}{" "}
                cm | <strong>Weight:</strong>{" "}
                {getPatientData("prescription_weight") || "N/A"} kg |{" "}
                <strong>BMI:</strong>{" "}
                {getPatientData("height_cm") && getPatientData("prescription_weight")
                  ? (
                    getPatientData("prescription_weight") /
                    (getPatientData("height_cm") / 100) ** 2
                  ).toFixed(1)
                  : "N/A"}
              </p>
            </Col>
          </Row>

          {/* <div className="row">
            <div className="col-lg-6 col-md-6">
              <strong style={{ fontSize: "16px", margin: "10px 0 5px" }}>
                Complaints:
              </strong>
              <ul style={{ listStyle: "none", padding: 0, fontSize: "14px" }}>
                <li style={{ marginBottom: "2px" }}>
                  {getPatientData("previous_histroy") || "N/A"} - complaint history
                </li>
                <li style={{ marginBottom: "2px" }}>
                  {getPatientData("notes") || "No additional notes"}
                </li>
              </ul>
            </div>

            <div className="col-lg-6 col-md-6">
              <strong style={{ fontSize: "16px", margin: "10px 0 5px" }}>
                Siemen Analysis
              </strong>
              <ul style={{ listStyle: "none", padding: 0, fontSize: "14px" }}>
                <li style={{ marginBottom: "2px" }}>
                  {getPatientData("siemen_analysis") ||
                    "No siemen analysis data available"}
                </li>
              </ul>
            </div>
          </div> */}

          {/* <div className="row">
            <div className="col-lg-6 col-md-6">
              <strong style={{ fontSize: "16px", margin: "10px 0 5px" }}>
                Examination:
              </strong>
              <ul style={{ listStyle: "none", padding: 0, fontSize: "14px" }}>
                <li style={{ marginBottom: "2px" }}>
                  {getPatientData("per_abutamon") ||
                    getPatientData("per_speculum") ||
                    getPatientData("per_virginal_exam") ||
                    getPatientData("previous_histroy") ||
                    "No examination data available"}
                </li>
              </ul>
            </div>

            <div className="col-lg-6 col-md-6">
              <strong style={{ fontSize: "16px", margin: "10px 0 5px" }}>
                Diagnosis
              </strong>
              <ul style={{ listStyle: "none", padding: 0, fontSize: "14px" }}>
                <li style={{ marginBottom: "2px" }}>
                  {getPrescriptionData("diagnosis") ||
                    "No diagnosis data available"}
                </li>
              </ul>
            </div>
          </div> */}

          {/* <div className="row">
            <div className="col-lg-6 col-md-6">
              <strong style={{ fontSize: "16px", margin: "10px 0 5px" }}>
                Scan
              </strong>
              <ul style={{ listStyle: "none", padding: 0, fontSize: "14px" }}>
                <li style={{ marginBottom: "2px" }}>
                  {getPrescriptionData("scan_findings") || "No scan findings available"}
                </li>
              </ul>
            </div>

            <div className="col-lg-6 col-md-6">
              <strong style={{ fontSize: "16px", margin: "10px 0 5px" }}>
                Treatment Plan:
              </strong>
              <p style={{ fontSize: "14px", margin: "2px 0" }}>
                {getPrescriptionData("plan_of_treatment") ||
                  getPatientData("plan_of_treatment") ||
                  "No treatment plan available"}
              </p>
            </div>
          </div> */}

          <Row style={{ marginTop: "15px" }}>
            <Col xs={12}>
              <strong
                style={{
                  fontSize: "20px",
                  marginBottom: "18px",
                }}
              >
                Medication Protocol
              </strong>
              <Table
                bordered
                responsive
                style={{
                  fontSize: "14px",
                  width: "100%",
                  borderCollapse: "collapse",
                }}
              >
                <thead>
                  <tr>
                    <th style={{ padding: "5px", border: "1px solid #000" }}>
                      Medication
                    </th>
                    <th style={{ padding: "5px", border: "1px solid #000" }}>
                      Dosage
                    </th>
                    <th style={{ padding: "5px", border: "1px solid #000" }}>
                      Timing - Duration
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {responseData?.medicines?.length
                    ? responseData.medicines.map((medicine, index) => (
                      <tr key={index}>
                        <td
                          style={{
                            padding: "5px",
                            border: "1px solid #000",
                          }}
                        >
                          {index + 1}){" "}
                          <strong>{medicine.medicine_name}</strong>
                          <br />
                          <small style={{ fontSize: "12px" }}>
                            Composition: {medicine.medicine_name}
                          </small>
                        </td>
                        <td
                          style={{
                            padding: "5px",
                            border: "1px solid #000",
                          }}
                        >
                          {medicine.dosage}
                        </td>
                        <td
                          style={{
                            padding: "5px",
                            border: "1px solid #000",
                          }}
                        >
                          {formatTiming(medicine.timing)} -{" "}
                          {medicine.duration}
                        </td>
                      </tr>
                    ))
                    : responseData?.prescription_data_details?.flatMap(
                      (prescription, prescriptionIndex) =>
                        prescription.medicines?.length
                          ? prescription.medicines.map((medicine, index) => (
                            <tr key={`${prescription._id}-${index}`}>
                              <td
                                style={{
                                  padding: "5px",
                                  border: "1px solid #000",
                                }}
                              >
                                {index + 1}){" "}
                                <strong>{medicine.medicine_name}</strong>
                                <br />
                                <small style={{ fontSize: "12px" }}>
                                  Composition: {medicine.medicine_name}
                                </small>
                              </td>
                              <td
                                style={{
                                  padding: "5px",
                                  border: "1px solid #000",
                                }}
                              >
                                {medicine.dosage}
                              </td>
                              <td
                                style={{
                                  padding: "5px",
                                  border: "1px solid #000",
                                }}
                              >
                                {formatTiming(medicine.timing)} -{" "}
                                {medicine.duration}
                              </td>
                            </tr>
                          ))
                          : prescription.medicine_name
                            ? [
                              <tr
                                key={`${prescription._id}-${prescriptionIndex}`}
                              >
                                <td
                                  style={{
                                    padding: "5px",
                                    border: "1px solid #000",
                                  }}
                                >
                                  {prescriptionIndex + 1}){" "}
                                  <strong>
                                    {prescription.medicine_name}
                                  </strong>
                                  <br />
                                  <small style={{ fontSize: "12px" }}>
                                    Composition: {prescription.medicine_name}
                                  </small>
                                </td>
                                <td
                                  style={{
                                    padding: "5px",
                                    border: "1px solid #000",
                                  }}
                                >
                                  {prescription.dosage}
                                </td>
                                <td
                                  style={{
                                    padding: "5px",
                                    border: "1px solid #000",
                                  }}
                                >
                                  {formatTiming(prescription.timing)} -{" "}
                                  {prescription.duration}
                                </td>
                              </tr>,
                            ]
                            : []
                    ) || [
                      <tr key="no-medicines">
                        <td
                          colSpan="3"
                          style={{
                            padding: "5px",
                            border: "1px solid #000",
                            textAlign: "center",
                          }}
                        >
                          No medications prescribed
                        </td>
                      </tr>,
                    ]}
                </tbody>
              </Table>
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <strong style={{ fontSize: "16px", margin: "10px 0 5px" }}>
                Advice
              </strong>
              <p style={{ fontSize: "14px", margin: "2px 0" }}>
                {getPrescriptionData("advise") ||
                  getPatientData("advise") ||
                  "No advice available"}
              </p>
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <strong style={{ fontSize: "16px", margin: "10px 0 5px" }}>
                Monitoring Schedule:
              </strong>
              <ul style={{ fontSize: "14px", paddingLeft: "20px" }}>
                <li>Baseline scan as per menstrual cycle</li>
                <li>Follicular monitoring as advised</li>
                <li>Repeat scan as advised</li>
              </ul>
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <strong style={{ fontSize: "16px", margin: "10px 0 5px" }}>
                Instructions:
              </strong>
              <ul style={{ fontSize: "14px", paddingLeft: "20px" }}>
                <li>
                  {getPrescriptionData("instructions") ||
                    "Follow up as advised"}
                </li>
                <li>Maintain healthy diet and moderate exercise</li>
              </ul>
            </Col>
            <Col
              xs={12}
              style={{
                textAlign: "right",
                fontWeight: "bold",
                fontSize: "14px",
                paddingTop: "60px",
              }}
            >
              <p style={{ margin: "10px 0" }}>
                {getDoctorData("doctor_name") || "Yoga Instructor"},
                {getDoctorData("qualification")}
              </p>
            </Col>
          </Row>

          <hr style={{ margin: "10px 0", border: "1px solid #000" }} />

          <Row>
            <Col xs={12} style={{ textAlign: "center", fontSize: "12px" }}>
              <p style={{ color: "#000", margin: "2px 0" }}>
                <i className="fa-solid fa-phone"></i>{" "}
                {getDoctorData("mobile_no") || "+91 99448 44408"} |{" "}
                <i className="fa-regular fa-envelope"></i>{" "}
                {getDoctorData("email") || "info@4healthhomeopathy.com"}
              </p>
              <div style={{ color: "#000000", margin: "2px 0" }}>
                Developed By Aalantechsoft-Salem
              </div>
            </Col>
          </Row>
        </Container>
        <div className="mt-2 d-print-none">
          <button className="btn btn-primary btn-sm me-2" onClick={handlePrint}>
            Print
          </button>
        </div>
      </div>
      <style>
        {`
          @media print {
            .print-right {
              text-align: right !important;
            }
            body {
              margin: 0;
              padding: 0;
              font-size: 12px;
              margin-top: 20px !important;
            }
            .container-fluid {
              width: 100%;
              max-width: 210mm;
              padding: 5mm;
              margin: 0;
              box-sizing: border-box;
            }
            h2 {
              font-size: 18px !important;
              margin-bottom: 8px !important;
            }
            h4, h5 {
              font-size: 14px !important;
              margin: 5px 0 !important;
            }
            p, li, td, th, small {
              font-size: 12px !important;
              line-height: 1.3 !important;
              margin-bottom: 3px !important;
            }
            img {
              max-width: 80px !important;
            }
            hr {
              margin: 8px 0 !important;
              border: 1px solid #000 !important;
            }
            table {
              width: 100% !important;
              margin-bottom: 8px !important;
              border-collapse: collapse !important;
            }
            th, td {
              padding: 3px !important;
              border: 1px solid #000 !important;
            }
            @page {
              size: A4;
              margin: 5mm;
            }
          }
        `}
      </style>
    </>
  );
};

export default Hospitalbill;
